import { Button, FormControl, FormLabel, Input } from '@chakra-ui/react'
import { useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useVerifyUserEmail from '../../hooks/useVerifyUserEmail'
import LogInHeading from '../LogInHeading'

export const LOGIN_EMAIL_VERIFICATION_TEST_IDS = Object.freeze({
  input: 'login-emai-verification-input',
  button: 'login-emai-verification-btn',
})

const LogInEmailVerification: React.FC = () => {
  const [t] = useTranslation()
  const { verifyEmail, isLoading } = useVerifyUserEmail()
  const form = useFormik({
    initialValues: {
      email: '',
    },
    onSubmit: (values) => {
      verifyEmail(values.email)
    },
  })
  return (
    <>
      <LogInHeading />
      <form onSubmit={form.handleSubmit}>
        <FormControl id='email' isInvalid={!!(form.errors.email && form.touched.email)}>
          <FormLabel
            htmlFor='email'
            fontFamily='Mulish'
            fontWeight='700'
            color='gray.800'
            fontSize='16px'
            marginBottom='2px'
          >
            {t('login.E-mail')}
          </FormLabel>
          <Input
            variant='loginInput'
            type='email'
            data-testid={LOGIN_EMAIL_VERIFICATION_TEST_IDS.input}
            placeholder={t('login.Enter your e-mail')}
            borderRadius='16px'
            onChange={form.handleChange}
            value={form.values.email}
            borderColor='gray.500'
            fontSize='1rem'
          />
        </FormControl>
        <Button
          type='submit'
          isLoading={isLoading}
          data-testid={LOGIN_EMAIL_VERIFICATION_TEST_IDS.button}
          variant='loginDark'
          marginTop='31px'
        >
          {t('login.Login')}
        </Button>
      </form>
    </>
  )
}

export default LogInEmailVerification
